import React from 'react'
import { useState, useRef, useMemo } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import NotificationAlert from "react-notification-alert";
import Notify from "../../lib/Utils/Alert";
// import Supplier from "../../lib/Core/Backend/Controllers/Supplier";
// ../css/modalUploadCSV.module.css
import { ReactComponent as UploadIcon } from "../../assets/img/upload.svg";
import * as modalCSVcss from "../Supplier/css/modalUploadCSV.module.css";
import okIMG from "../../assets/img/ok.png";
function UploadCsv({ toggle, modal, token, uploadJson }) {
    
  return (
    <>
  

        <Modal
        isOpen={modal}
        toggle={() => { toggle() }}
        backdrop="static"
        centered={true}
        size="lg"
      >
        <ModalHeader toggle={() => { toggle()}} className="bg-info">
          Upload CSV
        </ModalHeader>
        <ModalBody>
          <div className={modalCSVcss.container}>
            <div className="text">
              <p>Please select a file of type CSV and press send.</p>
            </div>
            <label htmlFor="file" className={modalCSVcss.formContainer}>
              <UploadIcon />
              <span>File Upload CSV</span>
              <input
                type="file"
                name=""
                id="file"
                className={modalCSVcss.dn}
                // onChange={uploadHandler}
                // ref={file}
                accept=".csv"
              />
            </label>
            {/* {fileCsv?.name && (
              <div className={modalCSVcss.fileSelected}>
                <p>
                  {fileCsv.name}{" "}
                  <span className="arrow">
                    <img src={okIMG} alt="" />
                  </span>
                </p>
              </div>
            )}
            {isProcessing && (
              <div className="d-flex align-items-center">
                <p className="mr-2 mb-0 font-weight-bold">Order is processing</p>
                <div className="spinner-border spinner-border-sm text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            )} */}
          </div>
        </ModalBody>
        <ModalFooter>

          <ModalFooter>
            <button className="btn btn-secondary" onClick={() => {toggle()}}>
              Close
            </button>
           
              <button className="btn btn-primary">
                Send
              </button>
           
          </ModalFooter>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default UploadCsv